import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=a7045c8e&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7045c8e')) {
      api.createRecord('a7045c8e', component.options)
    } else {
      api.reload('a7045c8e', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=a7045c8e&", function () {
      api.rerender('a7045c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4XF5IVD2DdGb5/JS/childrenage.vue"
export default component.exports